import React from "react"
import classnames from "classnames"
import styles from "./YoutubePlayer.less"


class YoutubePlayer extends React.PureComponent {
  render() {
    const { youtubeId, autoPlay = false, youtubeLink } = this.props
    return (
      <div className={classnames({
        [styles.YoutubePlayer]: true
      })}>

        {(youtubeId || youtubeLink) &&
          <iframe
            className={classnames({
              [styles.YoutubePlayerIframe]: true
            })}
            title="YoutubePlayer"
            src={youtubeLink || `https://www.youtube.com/embed/${youtubeId}?autoplay=${autoPlay ? 1 : 0}&rel=0`}
            allowFullScreen />
        }
        {!youtubeId && !youtubeLink &&
          <div>
            YoutubeId has not been provided
          </div>
        }
      </div>
    )
  }
}

export default YoutubePlayer



// WEBPACK FOOTER //
// ./src/AtomicComponents/YoutubePlayer/YoutubePlayer.jsx